<template>
  <div class="lang-select">
    <span class="lang-text">{{ currentLanguageLabel }}</span>
    <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
      <div>
        <svg-icon class-name="international-icon" icon-class="icon-earth" />
        <i class="el-icon-arrow-down icon-arrow-down" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :disabled="language === 'zh'" command="zh">
          Chinese
        </el-dropdown-item>
        <el-dropdown-item :disabled="language === 'en'" command="en">
          English
        </el-dropdown-item>
        <el-dropdown-item v-if="isMX || isGlobal" :disabled="language === 'es'" command="es">
          Español
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>

</template>

<script>
import getPageTitle from '@/utils/get-page-title'
export default {
  computed: {
    isMX() {
      return this.$store.getters.isMX
    },
    isGlobal() {
      return this.$store.getters.isPii
    },
    language() {
      return this.$store.getters.language
    },
    currentLanguageLabel() {
      if (this.language === 'zh') return 'Chinese'
      if (this.language === 'es') return 'Español'
      return 'English'
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      document.title = getPageTitle(this.$route.meta.title)
      this.$message({
        message: 'Switch Language Success',
        type: 'success'
      })
    }
  }
}
</script>
<style scoped>
.lang-select{
  position: relative;
  top: -4px;
}
.lang-text{
  margin-right: 8px;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 12px;
  color: #7A869E;
}
.icon-arrow-down{
  margin-left: 12px;;
  font-size: 12px;
  font-weight: bold;
}
.international-icon{
  font-size: 14px;
}
@media screen and (max-width: 761px) {
 .lang-text{
  display: none;
 }
}
</style>
